import { Container } from "../Container";
export class Rectangle extends Container {
    constructor(stage) {
        super(stage);
        this.el.texture = stage.rectangleTexture;
    }
}
//# sourceMappingURL=Rectangle.js.map